import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import CompareLoanEstimates from "@/pages/tools/CompareLoanEstimates";

export const Route = createFileRoute("/tools/compare-loan-estimates")({
  head: () => seoHead("/tools/compare-loan-estimates"),
  component: CompareLoanEstimates,
});
